const urlPart = '?token='
export const pureToken = 'a2df5f1950ae528223d4aab9050be1dd';//'7a56e20944c948f616f709a5a5734f42';
export const token = `${urlPart}${pureToken}`;
export const apiUrl = 'https://pcfy.redberryinternship.ge/api/';